module.exports = __webpack_public_path__ + "static/track-1-ca962c4191919e67e6dc18d5e0091e78.jpg";